<scale-telekom-footer type="minimal">
  <scale-telekom-footer-content>
    <span slot="notice">
      © Deutsche Telekom AG
    </span>

    <!-- Footer navigation -->
    <ul slot="navigation">
      <li><a href="#">Data privacy</a></li>
      <li><a href="#">Terms and conditions</a></li>
      <li><a href="#">Product information sheet</a></li>
    </ul>
  </scale-telekom-footer-content>
</scale-telekom-footer>
